/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page MNG_Equipment007
 * @created at      :   2025/10/27
 * @created by      :   quanlh
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    Keyword: '',
    TargetDate: '',
    GroupID: '',
    messages: [],
    inbox: [],
    // message form
    internal: {
        isReply: false,
        MDCD: '',
        MDName: '',
        EmployeeCD: '',
        EmployeeName: '',
        Subject: '',
        Body: ''
    },
    external: {
        MDCD: '',
        MDName: '',
        ClientCD: '',
        ClientName: '',
        BranchCD: '',
        BranchName: '',
        UserID: '',
        UserName: '',
        Subject: '',
        Body: ''
    },
    group: {
        GroupID: '9999999',
        MDCD: '',
        Subject: '',
        Body: ''
    },
    // manage group
    listGroup: [],
    groupDetail: {
        GroupName: '',
        LineNo: '',
        ShowType: '',
        members: [
            {
                EmployeeCD: '',
                EmployeeName: '',
                LineNo: 1
            }
        ]
    },
    groupKeyWord: '',
    // manage folder
    isFolderManagement: false,
    searchFolder: {
        Keyword: '',
        BoxType: 0,
        MessageType: 0,
        ActiveFLG: 1
    },
    listFolder: [],
    folderDetail: {
        FolderName: '',
        LineNo: '',
        BoxType: 0,
        MessageType: 0,
        ActiveFLG: 1,
        members: [
            {
                EmployeeCD: '',
                EmployeeName: '',
                LineNo: '1'
            }
        ]
    },
    folderCount: []
};

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        options: {
            group: [
                { code: 1, name: '全てのグループ' },
                { code: 2, name: '営業部グループ' },
                { code: 3, name: '開発チームグループ' },
                { code: 4, name: '人事部グループ' },
                { code: 5, name: '経営企画グループ' },
                { code: 6, name: 'カスタマーサポートグループ' }
            ],
            groupMember: [
                {
                    GroupID: 1,
                    member: ['佐藤花子', '鈴木一郎']
                }
            ],
            ShowType: [
                { code: 0, name: '表示' },
                { code: 1, name: '非表示' }
            ],
            BoxType: [
                { code: 0, name: '受信' },
                { code: 1, name: '送信' }
            ],
            MessageType: [
                { code: 0, name: '社内' },
                { code: 1, name: '社外' }
            ]
        },
        selectOptionKey: ['id', 'content']
    },
    mutations: {
        resetDataInit(state) {
            state.data = JSON.parse(JSON.stringify(dataInit));
        },
        setListDM(state, data) {
            if (data.mode == 1) {
                state.data.messages = [];
                state.data.messages = data.data ?? [];
            } else if (data.mode == 2) {
                state.data.inbox = [];
                state.data.inbox = data.data ?? [];
            }
        },
        setListGroup(state, data) {
            const group = data.group?.filter((item) => item.ShowType != 1) ?? [];
            const member = data.member ?? [];

            state.options.group = [{ code: 9999999, name: '全てのグループ' }];
            group.forEach((item) => {
                state.options.group.push({
                    code: item.GroupID,
                    name: item.GroupName
                });
            });
            state.options.groupMember = [];
            state.options.groupMember = Object.values(
                member.reduce((acc, item) => {
                    const key = item.GroupID;

                    if (!acc[key]) {
                        acc[key] = {
                            GroupID: Number(key),
                            member: []
                        };
                    }

                    acc[key].member.push(item.EmployeeName);

                    return acc;
                }, {})
            );
        },
        setGroupManagement(state, data) {
            state.data.listGroup = [];
            state.data.listGroup = data?.group ?? [];
        },
        setGroupDetail(state, data) {
            state.data.groupDetail = {};
            state.data.groupDetail.members = [];
            state.data.groupDetail = data.group ?? {};
            state.data.groupDetail.members = data.member ?? [];
        },
        setFolderDetail(state, data) {
            state.data.folderDetail = {};
            state.data.folderDetail.members = [];
            state.data.folderDetail = data.group ?? {};
            state.data.folderDetail.members = data.member ?? [];
        },
        setFolderManagement(state, data) {
            state.data.isFolderManagement = data;
        },
        setFolder(state, data) {
            state.data.listFolder = [];
            state.data.listFolder = data?.group ?? [];
        },
        setFolderCount(state, data) {
            state.data.folderCount = [];
            state.data.folderCount = data ?? [];
        }
    },
    actions: {
        listDM(context, body) {
            try {
                repository.listDM(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setListDM', { data: data.Data, mode: body.params.Mode });
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('listDM: ' + e.message);
            }
        },
        getGroup(context, body) {
            try {
                repository.getGroup(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        getFolder(context, body) {
            try {
                repository.getFolder(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getFolder: ' + e.message);
            }
        },
        getFolderCount(context, body) {
            try {
                repository.getFolderCount(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getFolderCount: ' + e.message);
            }
        },
        getFolderMessage(context, body) {
            try {
                repository.getFolderMessage(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getFolderMessage: ' + e.message);
            }
        },
        storeMessage(context, body) {
            try {
                repository.storeMessage(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        storeGroup(context, body) {
            try {
                repository.storeGroup(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        storeFolder(context, body) {
            try {
                repository.storeFolder(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        readMessage(context, body) {
            try {
                repository.readMessage(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback();
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        undoSendMessage(context, body) {
            try {
                repository.undoSendMessage(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        deleteGroup(context, body) {
            try {
                repository.deleteGroup(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('getGroup: ' + e.message);
            }
        },
        deleteFolder(context, body) {
            try {
                repository.deleteFolder(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('deleteFolder: ' + e.message);
            }
        },
        syncFolderMessage(context, body) {
            try {
                repository.syncFolderMessage(body.params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (body.callback) {
                            body.callback(data.Data ?? {});
                        }
                    }
                });
            } catch (e) {
                console.log('syncFolderMessage: ' + e.message);
            }
        }
    }
};
